/**
 * Globally-mounted SyncDataProgressDialog host (Slice 10c).
 *
 * The Confirm button in SyncDataDialog closes the picker and calls
 * `useSyncDataProgressDialogStore.getState().openSyncDataProgressDialog(...)`.
 * This host re-renders the dialog with the freshest args and routes Close
 * back through the store so any surface that opened the dialog can drop
 * its handle.
 */

import { lazy, Suspense } from 'react';
import { useSyncDataProgressDialogStore } from '../store/syncDataProgressDialogStore';

// Rendered only while open (see the `state.open` guard below), so the dialog and
// the data-compare runner it pulls stay out of the eager boot chunk.
const SyncDataProgressDialog = lazy(() =>
  import('./SyncDataProgressDialog').then((m) => ({ default: m.SyncDataProgressDialog })),
);

export function GlobalSyncDataProgressDialog() {
  const state = useSyncDataProgressDialogStore((s) => s.state);
  const closeSyncDataProgressDialog = useSyncDataProgressDialogStore(
    (s) => s.closeSyncDataProgressDialog,
  );

  if (!state.open) return null;

  return (
    <Suspense fallback={null}>
      <SyncDataProgressDialog
        open={state.open}
        folderPath={state.folderPath}
        link={state.link}
        tables={state.tables}
        onClose={() => closeSyncDataProgressDialog()}
      />
    </Suspense>
  );
}
